import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import connect from 'react-redux/es/connect/connect';
import { push } from 'react-router-redux/actions';
import Link from 'react-router-dom/Link';
import Button from 'react-bootstrap/es/Button';
import Dropdown from 'react-bootstrap/es/Dropdown';
import MenuItem from 'react-bootstrap/es/MenuItem';
import { toggleMenu } from 'redux/modules/MainMenu';
import { handleLogout, handleLoginStepTwo } from 'redux/modules/authentication';
import { enqueueModal } from 'redux/modules/modal';
import { roles } from 'config/constants';
import { sortByKey } from 'utils/helpers';
import JoinGroupModal from 'components/Group/JoinGroupModal';
import SelectGroupModal from 'components/Group/SelectGroupModal';
import './top-bar.css';

import avatar from 'images/avatar.png';
import logo from 'images/logo/logo5-beta.png';

class TopBar extends PureComponent {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        isAuthed: PropTypes.bool.isRequired,
        isAdmin: PropTypes.bool,
        isExecutive: PropTypes.bool,
        isCoach: PropTypes.bool,
        isOpened: PropTypes.bool.isRequired,
        location: PropTypes.object,
        profileData: PropTypes.object,
        isPublic: PropTypes.bool,
    }

    state = {
        isMenuOpened: false,
    }

    componentWillMount() {
        this.links = [];
    }

    toggleMenu = (e) => {
        e.preventDefault();

        this.props.dispatch(toggleMenu());

        this.setState({
            isMenuOpened: !this.state.isMenuOpened
        });
    }

    openCTXMenu = () => {
        const group = this.props.profileData.group;

        let options = {
            items: [
                {
                    text: (
                        <div className='user-header'>
                            <img src={this.props.profileData.avatar || avatar} alt='' />
                            <span>{this.props.profileData.email}</span>
                        </div>
                    ),
                    route: '/profile/edit'
                },
                {
                    text: (
                        <div className='context-right-icon'>
                            <span>Dashboard</span>
                            <i className='fa fa-tachometer' />
                        </div>
                    ),
                    route: this.props.isAdmin ? '/group/list' : '/pla/initial'
                },
                {
                    text: (
                        <div className='context-right-icon'>
                            <span>{group ? (group.contacts_name || 'MDS Contacts') : 'MDS Contacts'}</span>
                            <i className='fa fa-address-book-o' />
                        </div>
                    ),
                    route: '/contacts'
                }
            ]
        };

        if (!this.props.isAdmin) {
            options.items.push({
                text: (
                    <div className='context-right-icon'>
                        <span>{group ? (group.reminders_name || 'Reminder Alerts') : 'Reminder Alerts'}</span>
                        <i className='fa fa-bell-o' />
                    </div>
                ),
                route: '/reminders'
            });
        }
        else {
            options.items.push({
                type: 'action',
                text: (
                    <div className='context-right-icon'>
                        <span>Join Group</span>
                        <i className='fa fa-users' />
                    </div>
                ),
                actionFn: () => {
                    this.props.dispatch(enqueueModal({
                        title: 'Join Group',
                        data: <JoinGroupModal profileData={this.props.profileData}/>
                    }));
                }
            });
        }

        if (Object.keys(this.props.profileData).length) {
            if (this.props.profileData.available_role.length || this.props.profileData.groups.length) {
                options.items.push({
                    text: (
                        <Dropdown pullRight={true} id='submenu' className='top-bar__greeting-submenu' key='submenu'>
                            <Dropdown.Toggle className='context-right-icon' bsStyle='link' noCaret={true}>
                                <span>Switch Account</span>
                                <i className='fa fa-exchange'/>
                            </Dropdown.Toggle>

                            <Dropdown.Menu className='top-bar__greeting-menu'>
                                {this.renderUserRoles()}
                            </Dropdown.Menu>
                        </Dropdown>
                    )
                });
            }
        }

        options.items.push({
            type: 'action',
            text: (
                <div className='context-right-icon'>
                    <span>Logout</span>
                    <i className='fa fa-sign-out' />
                </div>
            ),
            actionFn: this.logout
        });

        return options;
    }

    enterDashboard = () => {
        if (this.props.isAdmin) {
            this.props.dispatch(push('/group/list'));
        }
        else if (this.props.isCoach) {
            this.props.dispatch(push('/assignments/feedbacks'));
        }
        else {
            this.props.dispatch(push('/pla/initial'));
        }
    }

    logout = () => {
        this.props.dispatch(handleLogout());
    }

    handleSwitchUser = (roleType = null, groupId = null) => {
        this.props.dispatch(handleLoginStepTwo(this.props.profileData.id, roleType, groupId, true));
    }

    renderUserRoles() {
        const roleOptions = sortByKey(this.props.profileData.available_role.map(userRole => {
            const obj = roles.filter(role => role.type === userRole);

            return obj[0];
        }), 'name');

        return roleOptions.map((role) =>
            <MenuItem
                key={role.type}
                onClick={() => {
                    role.type === 1
                        ? this.props.dispatch(enqueueModal({
                            title: 'Select Group',
                            data: <SelectGroupModal profileData={this.props.profileData} handleSwitchUser={this.handleSwitchUser}/>
                        }))
                        : this.handleSwitchUser(role.type);
                }}>
                <div className='context-right-icon'>
                    <span>{role.name}</span>
                </div>
            </MenuItem>
        );
    }

    renderLinks = () => {
        return this.links.map((link, index) => {
            const path = this.props.location.pathname;

            let isActive = false;

            if (path.indexOf(link.path) !== -1) {
                isActive = true;
            }

            return (
                <li key={`men_${index}`}>
                    <a href={link.path} className={`menu-link${isActive ? ' active' : ''}`}> {link.text} <span className='border-active'/></a>
                </li>
            );
        });
    }

    renderHomeMenu = () => {
        return (
            <div className={`home-menu ${this.props.isOpened ? 'active' : ''}`}>
                <ul>
                    {this.renderLinks()}
                    <li>
                        <Button
                            className='btn--home'
                            onClick={this.enterDashboard}>
                            Enter Dashboard
                        </Button>
                    </li>
                </ul>
            </div>
        );
    }

    render() {
        return (
            <div className='top-bar'>
                <div className='top-bar__container'>
                    <div className={`top-bar__menu ${this.state.isMenuOpened ? 'active' : ''}`}>
                        <a href='/' onClick={this.toggleMenu}>
                            <span className='b1' />
                            <span className='b2' />
                            <span className='b3' />
                        </a>
                    </div>
                    <div className='top-bar__brand'>
                        <Link to='/'>
                            <img src={logo} alt=''/>
                        </Link>
                    </div>
                    {this.props.location.pathname === '/' ? this.renderHomeMenu() : null}
                    {this.props.isAuthed && !this.props.isPublic ? (
                        <Dropdown
                            id='dropdown-custom-menu'
                            className='top-bar__greeting'
                            pullRight={true}>
                            <Dropdown.Toggle noCaret={true} className='top-bar__greeting-btn' bsStyle='link'>
                                <p>Hi {this.props.profileData.email}</p>
                                <img className='top-bar__greeting-img' src={this.props.profileData.avatar || avatar} alt=''/>
                                <i className='fa fa-sort-desc' />
                            </Dropdown.Toggle>

                            <Dropdown.Menu className='top-bar__greeting-menu'>
                                {this.openCTXMenu().items.map((item, i) => (
                                    item.route || item.actionFn
                                        ?
                                        <MenuItem
                                            key={i}
                                            className='top-bar__greeting-item'
                                            href={item.route ? item.route : null}
                                            onClick={item.actionFn ? item.actionFn : null}>
                                            {item.text}
                                        </MenuItem>
                                        : item.text
                                ))}
                            </Dropdown.Menu>
                        </Dropdown>

                    ) : null}
                </div>
            </div>
        );
    }
}

function mapStateToProps({ MainMenu, authentication }) {
    return {
        isOpened: MainMenu.showMenu,
        isAuthed: authentication.isAuthed,
        isAdmin: authentication.isAdmin,
        isCoach: authentication.isCoach,
        isExecutive: authentication.isExecutive,
        profileData: authentication.profileData,
    };
}

export default connect(mapStateToProps)(TopBar);



// WEBPACK FOOTER //
// ./src/components/TopBar/TopBar.js